export const optionsUsers = {
  scales: {
    yAxis: {
      beginAtZero: true,

      ticks: {
        color: "#ffffff",
      },
      title: {
        display: true,
        color: "#ffffff",
        text: "90th Percentile",
      },
    },
    xAxis: {
      ticks: {
        color: "#ffffff",
        maxTicksLimit: 10,
      },
      title: {
        display: true,
        color: "#ffffff",
        text: "Start Time",
      },
    },
  },
};

export const optionSla = {
  scales: {
    yAxis: {
      beginAtZero: true,

      ticks: {
        color: "#ffffff",
      },
      title: {
        display: true,
        color: "#ffffff",
        text: "Average Sla",
      },
    },

    xAxis: {
      ticks: {
        color: "#ffffff",
        maxTicksLimit: 10,
      },
      title: {
        display: true,
        color: "#ffffff",
        text: "Start Time",
      },
    },
  },
};

export const optionNoOfHits = {
  scales: {
    yAxis: {
      beginAtZero: true,

      ticks: {
        color: "#ffffff",
      },
      title: {
        display: true,
        color: "#ffffff",
        text: "Number of Hits Achieved",
      },
    },

    xAxis: {
      ticks: {
        color: "#ffffff",
        maxTicksLimit: 10,
      },
      title: {
        display: true,
        color: "#ffffff",
        text: "Start Time",
      },
    },
  },
};

export const optionThroughput = {
  scales: {
    yAxis: {
      beginAtZero: true,

      ticks: {
        color: "#ffffff",
      },
      title: {
        display: true,
        color: "#ffffff",
        text: "Throughput",
      },
    },

    xAxis: {
      ticks: {
        color: "#ffffff",
        maxTicksLimit: 10,
      },
      title: {
        display: true,
        color: "#ffffff",
        text: "Start Time",
      },
    },
  },
};
